import { getScreenName } from '../../../Utils/helper';
import { getPriceParams } from '../../../Utils/productPageUtils';
import { Tooltip, TooltipImage } from '../PdpCarousel/styled';
import { fireEvent } from '../../../Utils/fireEvent';

export function getEmbedUrl(item) {
  const id = item.split('=');
  const videoThumbnail = `https://img.youtube.com/vi/${id[1]}/hqdefault.jpg`;
  const videoId = `${id[1]}`;
  const embedUrl = `https://www.youtube.com/embed/${id[1]}?enablejsapi=1`;
  return { embedUrl, videoId, videoThumbnail };
}

export function videoExist(Url) {
  return new RegExp('^(https?://)?(www.youtube.com|youtu.be)/.+$').test(Url);
}

export function getImages(product, count_images, ImagesAltText) {
  let images = [];

  product?.images?.map((item, index) => {
    if (videoExist(item)) {
      const { embedUrl, videoId, videoThumbnail } = getEmbedUrl(item);
      let obj = {
        original: 'video',
        thumbnail: 'video',
        embedUrl: embedUrl,
        videoId: videoId,
        videoThumbnail: videoThumbnail,
        index: index,
      };
      images.push(obj);
    } else {
      const tooltip = product?.toolTipData?.[index];
      let obj = {
        original: item,
        thumbnail: item,
        index: index,
        description:
          tooltip != undefined ? getOriginalTitle(index, tooltip) : null,
        image_alt_text: ImagesAltText?.[index] || '',
      };
      images.push(obj);
    }
  });
  if (count_images > 0) {
    images.push({
      type: 'custom',
      section: 'User_review_images',
      thumbnail: 'item',
      index: product?.images?.length,
    });
  }

  return images;
}

export function getOriginalTitle(index, tooltipdata) {
  return (
    <Tooltip color={index % 2 == 0 ? '#FDEAEA' : '#C9EEDA'}>
      <TooltipImage
        src={tooltipdata?.icon}
        loading={index != 0 ? 'lazy' : undefined}
        alt="tooltip icon"
      />
      {tooltipdata?.text}
    </Tooltip>
  );
}

export function getVedioID(Url) {
  const { embedUrl, videoId, videoThumbnail } = getEmbedUrl(Url);
  return videoId;
}

export function getActionString(action) {
  switch (action) {
    case 1:
      return 'play';
    case 2:
      return 'pause';

    default:
      break;
  }
}

export const fireThumbnailClickEvent = (event, index, product) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'clicked_product_thumbnail',
    id: product.id,
    name: product.name,
    screen_name: 'PDP',
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    position: index,
  });
};
export const fireVedioClickEvent = (item, product) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'clicked_thumbnail_video',
    id: product.id,
    name: product.name,
    screen_name: 'PDP',
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    object_id: item?.videoId,
    section_name: 'video_thumnail',
  });
};
export const fireViewedPopupEvent = (product, parent) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'viewed_popup',
    id: product?.id,
    name: product?.name,
    screen_name: getScreenName(),
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    section_name: 'video_thumnail',
    parent: parent,
  });
};
export const fireDiscardPopupEvent = (product, parent) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'discard_popup',
    id: product?.id,
    name: product?.name,
    screen_name: getScreenName(),
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    section_name: 'video_thumnail',
    parent: parent,
  });
};
export const fireVedioActionEvent = (product, action, videoId, autoplay) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'video_action',
    action: getActionString(action),
    id: product?.id,
    name: product?.name,
    screen_name: getScreenName(),
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    section_name: 'video_thumnail',
    object_id: videoId,
    autoplay: autoplay,
  });
};

export const clicked_card_in_pdp = (
  event,
  index,
  product,
  max_position,
  parent,
  isImageReview,
) => {
  const { pricingParam, conversionParam } = getPriceParams(product);
  fireEvent({
    category: 'clicked_card_in_pdp',
    card_id: product?.id,
    card_name: product?.name,
    screen_name: 'PDP',
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    position: index,
    selling_price: product?.price,
    section_name: 'listing image carousel',
    deeplink_value: product?.web_url,
    max_position: max_position,
    parent: parent,
    sku_nickname: product?.nickname,
    isUserImage: isImageReview || false,
  });
};

export const ParamToAdd = 'video';
export const thumbnailPosition = 'bottom';
export const thumbnailPositionDesktop = 'left';
export const UrlIncluded = 'imageGallery';
export const autoPlayVideo = 1;
export const videoParent = 'video_thumbnail';
